import React from 'react';
import { HorizontalLayout, VerticalLayout, TranslatedLabelWithData } from '@vcc-gcs/bookingengine-shared-frontend';
import { Temporal } from '@js-temporal/polyfill';
import { TimeLineSectionHeading } from '../TimeLineSectionHeading';
import { Text } from 'vcc-ui';
import { formattedDate, formattedTime } from '../../../shared/domain/utils/dateUtils';
import { useTranslation } from 'react-i18next';

export const DateTimeCard = ({ convenienceOptions, pickupAddress, timeslots }) => {
  const { t, i18n } = useTranslation();

  const timeString = (() => {
    if (!timeslots[0].zonedStartTime) {
      // if the booking was made before the zoned time support
      // fallback to the old way of displaying the date and time
      return [
        `${formattedDate(timeslots[0].start, i18n.language)}, ${formattedTime(timeslots[0].start, i18n.language)}`,
        timeslots[0].end && formattedTime(timeslots[0].end, i18n.language),
      ]
        .filter(Boolean)
        .join(' - ');
    }

    const startTime = Temporal.ZonedDateTime.from(timeslots[0].zonedStartTime);
    const endTime = timeslots[0].zonedEndTime && Temporal.ZonedDateTime.from(timeslots[0].zonedEndTime);
    return [
      startTime.toLocaleString(i18n.language, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }),
      endTime &&
        endTime.toLocaleString(i18n.language, {
          ...(!startTime.toPlainDate().equals(endTime.toPlainDate()) && {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          }),
          hour: '2-digit',
          minute: '2-digit',
        }),
    ]
      .filter(Boolean)
      .join(' - ');
  })();

  return (
    <HorizontalLayout id={'bookingContent-date-time'} style={{ margin: '0.5em 0em' }} className={'date-time'}>
      <VerticalLayout data-test-id={'dateandTime'} className={'date-time-content'} spacing={10}>
        <TimeLineSectionHeading>{t(`appointments.eventType.appointment.datetime`)}</TimeLineSectionHeading>
        <ul>
          <li>
            <Text>{timeString}</Text>
          </li>
          {convenienceOptions.map((convenienceOption) => (
            <li key={convenienceOption.node.uid}>
              <Text data-test-id={'dropoffOptionText'}>{convenienceOption.node.heading}</Text>
              {convenienceOption.subConvenienceOptions?.length > 0 && (
                <ul>
                  {convenienceOption.subConvenienceOptions.map((subConvenienceOption) => (
                    <li key={subConvenienceOption.node.uid}>
                      <Text>{subConvenienceOption.node.heading}</Text>
                    </li>
                  ))}
                </ul>
              )}
              {convenienceOption.location?.address && (
                <li>
                  <Text data-test-id={'pickupAddress'} as="div">
                    <TranslatedLabelWithData
                      textId={`appointments.eventType.appointment.pickupAddress`}
                      data={convenienceOption.location?.address.join(' ')}
                    />
                  </Text>
                </li>
              )}
            </li>
          ))}
        </ul>
      </VerticalLayout>
    </HorizontalLayout>
  );
};
